export default __webpack_public_path__ + "static/bunnynet-pricing-f8946aee4549d0a38e11e80b77336fce.svg";